module.exports = __webpack_public_path__ + "static/img/91_IMG_20170525_145654.cb361445.jpg";